import {useMemo} from 'react';

import {useSelector} from '../../../../state/hooks';
import {APIAddedPanelSpecs, DefaultPanelSpecs} from '../../../PanelBank/types';
import {QuickAddKeys} from '../PanelsQuickAddContext';

interface ExpectedPanels {
  defaultSpecs: DefaultPanelSpecs;
  apiAddedSpecs: APIAddedPanelSpecs;
}

let memoizedExpectedPanels: ExpectedPanels | null = null;
let memoizedQuickAddKeys: QuickAddKeys | null = null;

function memoizedSortedQuickAddKeys(expectedPanels: ExpectedPanels) {
  if (expectedPanels === memoizedExpectedPanels && memoizedQuickAddKeys) {
    return memoizedQuickAddKeys;
  }

  const {defaultSpecs, apiAddedSpecs} = expectedPanels;
  const result = [
    ...Object.entries(defaultSpecs),
    ...Object.entries(apiAddedSpecs),
  ].sort((a, b) => a[0].localeCompare(b[0]));

  memoizedExpectedPanels = expectedPanels;
  memoizedQuickAddKeys = result;
  return result;
}

export const useSearchedKeys = (searchStr: string) => {
  const expectedPanels = useSelector(state => state.expectedPanels);

  const allQuickAddKeys = useMemo(() => {
    if (!expectedPanels) {
      return [];
    }

    return memoizedSortedQuickAddKeys(expectedPanels);
  }, [expectedPanels]);

  return useMemo(() => {
    try {
      if (!searchStr) {
        return allQuickAddKeys;
      }
      const regex = new RegExp(searchStr, 'i');
      return allQuickAddKeys.filter(([key]) => regex.test(key));
    } catch (e) {
      console.log('error while running regex: ', {e});
      return [];
    }
  }, [allQuickAddKeys, searchStr]);
};
